import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Button from "./Button";
import ActionButton from "./ActionButton";

const Controls = {
  Input,
  RadioGroup,
  Select,
  Button,
  ActionButton,
};

export default Controls;
